import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { colorConverterMap } from './colorPropsToCss'

/**
 * Enriches the converters registry with all color-related style property converters.
 * Color converters handle color types and their various representations.
 */
export function enrichColorConverters(): void {
	// Register all color converters
	Object.entries(colorConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
